module.exports = __webpack_public_path__ + "static/media/emailClickedIcon.e247abc9.svg";